module.exports = __webpack_public_path__ + "img/DE00496.f037dc54.png";